<template>
  <v-container
    fluid
    class="pa-0 pr-4"
  >
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        class="pt-5 karte"
      >
        <v-textarea
          v-model="karte.trace"
          variant="outlined"
          name="line"
          label="LINE貼り付け欄
          *運営が行います"
          rows="10"
          :readonly="!active"
          class="pt-1 pb-0 linefeed-label"
          hide-details
        />
        <v-card
          id="karte-images"
          :flat="true"
        >
          <v-card-actions
            v-if="$route.name == 'karte'"
          >
            <v-btn
              :disabled="!active"
              block
              color="white"
              class="font-weight-bold ml-0 upload"
              onclick="document.getElementById('upload-button').click()"
              theme="dark"
              style="background-color: #ec407a;"
            >
              画像／動画アップロード
              <v-icon icon="mdi-publish" />
            </v-btn>
            <input
              id="upload-button"
              type="file"
              multiple="multiple"
              style="display: none"
              @click="clearTargetValue"
              @change="onFileChange"
            >
          </v-card-actions>
          <load-state-display
            :state="karteImagesLoadState"
            reload-button-id="karte-images-reload-button"
            @reload="fetchKarteImages"
          />
          <v-container
            v-if="isSuccess(karteImagesLoadState)"
            fluid
            class="pb-0"
          >
            <v-row>
              <v-col
                v-for="madia in karteImageList"
                :key="madia.id"
                class="mb-0"
                md="2"
              >
                <v-card
                  :flat="true"
                  tile
                >
                  <img
                    v-if="madia.extension == 'jpg'"
                    :src="madia.url"
                    style="max-width: 90%; height: 48px; cursor: pointer;"
                    oncontextmenu="return false;"
                    onselectstart="return false;"
                    onmousedown="return false;"
                    @click="showMedia(madia)"
                  >
                  <video
                    v-if="madia.extension == 'mp4'"
                    :src="madia.url"
                    style="max-width: 90%; height: 48px; cursor: pointer;"
                    controlsList="nodownload"
                    oncontextmenu="return false;"
                    @click="showMedia(madia)"
                  />
                  <a
                    v-if="madia.extension == 'pdf'"
                    :href="`/api/v1/karte_images/${madia.id}/download`"
                    target="_blank"
                  >
                    <v-icon
                      size="48px"
                      style="border: 1px solid #CCC"
                      icon="mdi-pdf-box"
                    />
                  </a>
                  <p
                    v-if="active"
                    @click="deleteFile({ 'image': madia, 'reservation_id': $route.query.reservation_id })"
                  >
                    削除
                  </p>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <!-- modal -->
    <media-viewer-dialog
      v-model="mediaViewer.open"
      :src="mediaViewer.src"
      :title="mediaViewer.title"
      :kind="mediaViewer.kind"
      @error="onMediaViewerError"
    />
    <!--// modal -->
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loadStateMixin from "../../mixins/load_state.js";
import LoadStateDisplay from "../shared/LoadStateDisplay.vue";
import { LOAD_STATES } from "../../constants/load_states";
import {
  MEDIA_VIEWER_KINDS,
  MediaViewerDialog,
  createMediaViewerState,
  handleMediaViewerError,
  openMediaViewer,
} from "../../features/media-viewer";

export default {
  name: "KarteOperationFields",
  components: {
    LoadStateDisplay,
    MediaViewerDialog,
  },
  mixins: [loadStateMixin],
  props: {
    active: Boolean
  },
  data: () => ({
    mediaViewer: createMediaViewerState(),
    isKarteImageListLoaded: false,
    karteImageTimerId: null,
    karteImagesLoadState: null,
  }),
  computed: {
    ...mapGetters([
      "karte",
      "karteImageList",
      "reservation",
      "karteMediaFile"
    ]),
  },
  watch: {
    "$route" () {
      this.$store.dispatch("fetchKarteImages", {
        reservation_id: (this.$route.name == "karteView") ? this.$route.params.id : this.$route.query.reservation_id
      });
    }
  },
  created() {
    this.fetchKarteImages();
  },
  beforeUnmount() {
    clearTimeout(this.karteImageTimerId);
  },
  methods: {
    ...mapActions(["fetchKarteImages", "uploadFile", "deleteFile", "viewFile", "downloadFile"]),
    showMedia: function(madia) {
      this.viewFile(madia.id).then(() => {
        const extension = this.karteMediaFile.extension;
        const kind = extension === "mp4" ? MEDIA_VIEWER_KINDS.VIDEO : MEDIA_VIEWER_KINDS.IMAGE;
        openMediaViewer(this.mediaViewer, {
          src: this.karteMediaFile.url,
          title: "",
          kind,
        });
      });
    },
    onMediaViewerError() {
      handleMediaViewerError(this.mediaViewer);
    },
    onFileChange: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      let fileCount = e.target.files.length;

      for(let i = 0; i < fileCount; i++) {
        var formData = new FormData();
        formData.append("reservation_id", this.$route.query.reservation_id);
        formData.append("karte_id", this.karte.id);
        formData.append("filename", files[i]);
        this.uploadFile(formData);
      }
    },
    clearTargetValue: function(e) {
      e.target.value = "";
    },
    fetchKarteImages() {
      this.karteImagesLoadState = LOAD_STATES.LOADING;
      clearTimeout(this.karteImageTimerId);
      this.karteImageTimerId = setTimeout(() => {
        this.karteImagesLoadState = LOAD_STATES.ERROR;
      }, 30 * 1000);

      this.$store.dispatch("fetchKarteImages", {
        reservation_id: (this.$route.name == "karteView") ? this.$route.params.id : this.$route.query.reservation_id
      }).then(() => {
        this.karteImagesLoadState = LOAD_STATES.SUCCESS;
      }).catch(() => {
        this.karteImagesLoadState = LOAD_STATES.ERROR;
      }).finally(() => {
        clearTimeout(this.karteImageTimerId);
      });
    },
  },
};
</script>
